import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

import { CreditAgreements } from './CreditAgreements';
import { CreditAgreementsViewTemplate } from './CreditAgreementsViewTemplate';
import { z } from 'zod/v4';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';

// Types
const RouteParamsStruct = z.object({
  implementationId: z.string({ message: 'Missing URL parameter' }),
  creditFacilityId: z.string({ message: 'Missing URL parameter' }),
});

// Fragments
const RouteBase = () => {
  const params = useParams();
  const { creditFacilityId } = RouteParamsStruct.parse(params);

  return <CreditAgreements creditFacilityId={creditFacilityId} />;
};

// Exports
export const Route = () => {
  return (
    <RouteErrorBoundary
      fallback={({ message, showErrorToast }) => {
        showErrorToast(message);
        return <Navigate to="/" />;
      }}
    >
      <CreditAgreementsViewTemplate>
        <RouteBase />
      </CreditAgreementsViewTemplate>
    </RouteErrorBoundary>
  );
};
